import React, { useState, useEffect } from 'react';
import { Route, Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
// core components
import Header from "dashboard/general-management/components/Headers/Header.js";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {api} from '../../../../api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import Cookies from 'js-cookie';

const VendorList = () => {
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showAddClientModal, setShowAddClientModal] = useState(false);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);        
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [deleteEmployee, setdeleteEmployee] = useState(null);
  const [clientData, setClientData] = useState({
    vendor_name: '',
    vendor_address: '',
    vendor_number: '',
    vendor_email: '',
    vendor_website: '',
  });
  const [employeeIdToDelete, setEmployeeIdToDelete] = useState(null);

  // Success alert state
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  // Add state for validation error
  const [formError, setFormError] = useState('');

  const toggleDropdown = (id) => { 
    setDropdownOpen(prevState => ({
      ...prevState,
      [id]: !prevState[id]
    }));
  };

  const handleVendorInputChange = (e) => {
    const { name, value } = e.target;
    setClientData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission
    setFormError(''); // Reset error
    // Validation
    if (!clientData.vendor_name || !clientData.vendor_address || !clientData.vendor_number || !clientData.vendor_email) {
      setFormError('Please fill all required fields.');
      return;
    }
    // Remove profile image as required
    try {
      const formData = new FormData();
      formData.append("vendor_name", clientData.vendor_name);
      formData.append("vendor_address", clientData.vendor_address);
      formData.append("vendor_number", clientData.vendor_number);
      formData.append("vendor_email", clientData.vendor_email);
      formData.append("vendor_website", clientData.vendor_website);
      if (clientData.vendor_image) {
      formData.append("vendor_image", clientData.vendor_image);
      }

      const company_id = Cookies.get('company_id');
      formData.append("company_id", company_id);

      const response = await api.post(`addVendor.php`, formData);
      console.log("Data sent successfully:", response.data);
      if (response.data.status === 'success') {
        setSuccessMessage('Vendor added successfully!');
        setShowSuccessAlert(true);
        setTimeout(() => { window.location.reload(); }, 1200);
        toggleAddClientModal();
      } else {
        alert(response.data.message || 'Failed to add vendor');
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      alert('An error occurred while adding the vendor');
    }
  }; 

  const toggleModal = () => setModalOpen(prevState => !prevState);
  const toggleAddClientModal = () => setShowAddClientModal(prevState => !prevState);

  const handleAddClient = () => {
    setClientData({
      vendor_image: '',
      vendor_name: '',
      vendor_address: '',
      vendor_number: '',
      vendor_email: '',
      vendor_website: '',
    }); // Reset form data
    toggleAddClientModal();
  };

  const handleInputChange = (event) => {
    event.preventDefault(); 
    const {name, value}  = event.target;
    setClientData({
      ...clientData,
      [event.target.name]: event.target.value 
    }); 
  }; 

  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`addVendor.php?company_id=${company_id}`);
        if (response.data && response.data.vendors) {
          setTasks(response.data.vendors);
        } else {
          setTasks([]);
          console.warn('No vendors data received from API');
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setTasks([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  
  const employees = tasks; 

  const filterEmployees = () => {
    if (!searchQuery) {
      setFilteredEmployees(employees);
    } else {
      const filtered = employees.filter(employee => 
        employee.vendor_name && employee.vendor_name.toLowerCase().includes(searchQuery.toLowerCase())
      ); 
      setFilteredEmployees(filtered); 
    }
  };

  useEffect(() => { 
    filterEmployees();
  }, [searchQuery, tasks]);
  
  const toggleViewMoreModal = (employee) => {
    setSelectedEmployee(employee);
  };

  const renderViewMoreModal = () => {
    if (!selectedEmployee) return null;
    let imageSrc = null;
    if (selectedEmployee.vendor_image && selectedEmployee.vendor_image !== "null" && selectedEmployee.vendor_image !== null && selectedEmployee.vendor_image !== undefined && selectedEmployee.vendor_image !== "") {
      try {
        // Check if running in localhost
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
          imageSrc = require(`../../../images/${selectedEmployee.vendor_image}`);
        } else {
          // In deployment, use the /images/ path
          imageSrc = `/images/${selectedEmployee.vendor_image}`;
        }
      } catch (e) {
        imageSrc = null;
      }
    }
    return (
      <Modal isOpen={true} toggle={() => toggleViewMoreModal(null)}>
        <ModalHeader toggle={() => toggleViewMoreModal(null)}>Employee View</ModalHeader>
        <ModalBody style={{ justifyContent: 'flex-start', textAlign: 'left' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          {imageSrc ? (
            <img
              alt="..."
              className="rounded-circle"
              src={imageSrc}
              style={{
                width: 100,
                height: 100,
                borderRadius: '50%',
                objectFit: 'cover',
                display: 'block',
                boxShadow: '0 0 10px rgba(0,0,0,0.15)'
              }}
            />
          ) : (
            <div
              className="rounded-circle"
              style={{
                width: 100,
                height: 100,
                borderRadius: '50%',
                backgroundColor: '#ccc',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                fontSize: 16,
                boxShadow: '0 0 10px rgba(0,0,0,0.15)'
              }}
            >
              No Image
            </div>
          )}
            </div>
            {/* Three-column layout for details, colon aligned, Poppins font */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%', fontFamily: 'Poppins, sans-serif' }}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <span style={{ fontWeight: 'bold', minWidth: 130, textAlign: 'right', display: 'inline-block' }}>Vendor Name</span>
                <span style={{ width: 16, textAlign: 'center', display: 'inline-block' }}>:</span>
                <span style={{ marginLeft: 8 }}>{selectedEmployee.vendor_name}</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <span style={{ fontWeight: 'bold', minWidth: 130, textAlign: 'right', display: 'inline-block' }}>Email</span>
                <span style={{ width: 16, textAlign: 'center', display: 'inline-block' }}>:</span>
                <span style={{ marginLeft: 8 }}>{selectedEmployee.vendor_email}</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <span style={{ fontWeight: 'bold', minWidth: 130, textAlign: 'right', display: 'inline-block' }}>Mobile Number</span>
                <span style={{ width: 16, textAlign: 'center', display: 'inline-block' }}>:</span>
                <span style={{ marginLeft: 8 }}>{selectedEmployee.vendor_number}</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <span style={{ fontWeight: 'bold', minWidth: 130, textAlign: 'right', display: 'inline-block' }}>Address </span>
                <span style={{ width: 16, textAlign: 'center', display: 'inline-block' }}>:</span>
                <span style={{ marginLeft: 8 }}>{selectedEmployee.vendor_address}</span>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal> 
    );
  };

  const [deleteConfirmationEmployeeId, setDeleteConfirmationEmployeeId] = useState(null);

  const toggleDeleteConfirmationModal = (employeeId) => {
    setDeleteConfirmationEmployeeId(employeeId === deleteConfirmationEmployeeId ? null : employeeId);
  };

  const handleDropdownItemClick = (action, employeeId, employeeName) => {
    if (action === 'Delete') {
      toggleDeleteConfirmationModal(employeeId);
    } else {
      console.log(`Clicked ${action}`);
    }
  };

  const handleDeleteConfirmation = (confirmed, employeeId) => {
    if (confirmed) {
      const fetchData = async () => {
        try { 
          const company_id = Cookies.get('company_id');
          const response = await api.delete(`addVendor.php?vendor_id=${employeeId}&company_id=${company_id}`);
          if (response.data.status === 'success') {
            setSuccessMessage('Vendor deleted successfully!');
            setShowSuccessAlert(true);
            setDeleteConfirmationEmployeeId(null); // Close confirmation modal on success
          } else {
            alert(response.data.message || 'Failed to delete vendor');
            setDeleteConfirmationEmployeeId(null); // Close confirmation modal on error
          }
        } catch (error) {  
          console.error("Error deleting vendor:", error);
          alert('An error occurred while deleting the vendor');
          setDeleteConfirmationEmployeeId(null); // Close confirmation modal on error
        }  
      };  
      fetchData();
    } else {
      setDeleteConfirmationEmployeeId(null); // Close confirmation modal if No
    }
  };

  const [profileImage, setProfileImage] = useState(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      setProfileImage(URL.createObjectURL(file));
      setClientData({ ...clientData, vendor_image: event.target.files[0] });
    }
  };

  const displayClient = tasks && tasks.length > 0 ? tasks.filter(client => 
    client.vendor_name && client.vendor_name.toLowerCase().includes(searchQuery.toLowerCase())
  ) : [];

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
         <Row className="mb-4">
  <Col xs="12" className="d-flex justify-content-end align-items-center flex-nowrap" style={{ gap: '10px' }}>
    {/* Search Input */}
    <Form className="mb-0" style={{ flexShrink: 0 }}>
      <FormGroup className="mb-0">
        <InputGroup
          className="input-group-alternative"
          style={{
            height: '36px',
            width: '180px',
            border: '2px solid #1e3a8a', // dark blue border
            borderRadius: '20px',
            backgroundColor: '#fff',
            overflow: 'hidden',
          }}
        >
          <InputGroupAddon addonType="prepend">
            <InputGroupText style={{ backgroundColor: 'transparent', border: 'none', paddingRight: '0.5rem' }}>
              <i className="fas fa-search pb-5" style={{ color: '#1e3a8a' }} />
            </InputGroupText>
          </InputGroupAddon>
          <Input
            placeholder="Search Vendor Name"
            className='pb-4'
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{
              border: 'none',
              backgroundColor: 'transparent',
              boxShadow: 'none',
              fontSize: '0.9rem',
              paddingLeft: 0,
              paddingRight: '0.5rem',
             
            }}
          />
        </InputGroup>
      </FormGroup>
    </Form>

    {/* Compact Add Button */}
    <Button
      onClick={handleAddClient}
      className="mb-0"
      style={{
        backgroundColor: '#d86f89',
        borderColor: '#d86f89',
        color: 'black',
        height: '36px',
        padding: '4px 14px',
        fontSize: '0.875rem',
        fontWeight: 500,
        flexShrink: 0,
        whiteSpace: 'nowrap',
      }}
    >
      Add Vendor
    </Button>
  </Col>
</Row>


        </Container>
        <Container fluid>
          <Row className="g-3"> {/* Added g-3 for spacing between cards */}
            {displayClient.length === 0 ? (
              <Col md="12" className="text-center" style={{ color: '#888', fontWeight: 'bold', fontSize: '18px', marginTop: '40px' }}>
                No such vendor available.<br/>
                <Button
                  style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black', marginTop: '15px' }}
                  onClick={handleAddClient}
                >
                  Add New Vendor
                </Button>
              </Col>
            ) : (
              displayClient.map(employee => (
                <Col md="4" key={employee.vendor_id}> {/* Changed to md="4" for responsiveness */}
                  <Card
                    className="p-3 shadow-sm"
                    style={{
                      boxShadow: '10px 10px 22px 0px rgba(0,0,0,1)',backgroundColor: '#ffffff',
                      borderWidth: "2px",
                      borderStyle: "solid",
                      borderRadius: "15px",
                      borderColor: "rgba(207, 97, 124, 0.44)",
                      position: "relative",
                    }}
                  >
                    <Dropdown
                      isOpen={dropdownOpen[employee.vendor_id]}
                      toggle={() => toggleDropdown(employee.vendor_id)}
                      style={{ position: "absolute", top: "10px", right: "10px" }}
                    >
                      <DropdownToggle
                        tag="span"
                        data-toggle="dropdown"
                        aria-expanded={dropdownOpen[employee.vendor_id]}
                        caret
                        style={{ cursor: "pointer" }}
                      >
                        <i className="fas fa-ellipsis-v"></i>
                      </DropdownToggle>
                      <DropdownMenu>
                        <Link to={`/store-admin/store-management/editVendorName/${employee.vendor_id}`} style={{ color: 'Black' }}>
                          <DropdownItem>Edit</DropdownItem>
                        </Link>
                        <DropdownItem onClick={() => toggleDeleteConfirmationModal(employee.vendor_id)}>Delete</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                    <Row className="align-items-center">
                      <Col xs="4" className="text-center">
                        {employee.vendor_image && employee.vendor_image !== "null" && employee.vendor_image !== null && employee.vendor_image !== undefined && employee.vendor_image !== "" ? (
                          (() => {
                            let cardImageSrc = null;
                            try {
                              cardImageSrc = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' 
                                ? require(`../../../images/${employee.vendor_image}`)
                                : `/images/${employee.vendor_image}`;
                            } catch (e) {
                              cardImageSrc = null;
                            }
                            return cardImageSrc ? (
                              <img
                                alt="..."
                                className="rounded"
                                src={cardImageSrc}
                                style={{ height: 100, width: 100, objectFit: "cover" }}
                              />
                            ) : (
                              <div
                                className="rounded"
                                style={{
                                  height: 100,
                                  width: 100,
                                  backgroundColor: "#ccc",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                No Image
                              </div>
                            );
                          })()
                        ) : (
                          <div
                            className="rounded"
                            style={{
                              height: 100,
                              width: 100,
                              backgroundColor: "#ccc",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            No Image
                          </div>
                        )}
                      </Col>
                      <Col xs="8">
                        <div className="fw-bold mb-1" style={{ fontSize: "16px" }}>
                          {employee.vendor_name}
                        </div>
                        <div className="text-muted mb-1" style={{ fontSize: "14px", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }} title={employee.vendor_email}>
                          <i className="fas fa-envelope me-2"></i> {employee.vendor_email}
                        </div>
                        <div className="text-muted" style={{ fontSize: "14px" }}>
                          <i className="fas fa-phone me-2"></i> {employee.vendor_number}
                        </div>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-end mt-2">
                      <a
                        href="#pablo"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleViewMoreModal(employee);
                        }}
                        className="text-primary"
                        style={{ fontSize: "15px" }}
                      >
                        View More
                      </a>
                    </div>
                  </Card>
                </Col>
              ))
            )}
          </Row> 
        </Container>
      </div>

      <Modal isOpen={showAddClientModal} toggle={toggleAddClientModal}> 
        <ModalHeader toggle={toggleAddClientModal}>Add New Vendor</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <Row className="justify-content-center align-items-center">
              <Col lg="12" className="text-center mb-3">
                {!profileImage && (
                  <div
                    className="profile-image-container"
                    style={{
                      width: '120px',
                      height: '120px',
                      border: '2px solid black',
                      borderRadius: '50%',
                      overflow: 'hidden',
                      boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
                      margin: '0 auto',
                    }}
                  >
                    {clientData.vendor_image && (
                      <img
                      src={window.location.hostname === 'localhost' 
                          ? require(`../../../images/${tasks.profile_image}`) 
                          : `/images/${tasks.profile_image}`}
                        alt="Placeholder"
                        name="image"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    )}
                  </div>
                )}
                {profileImage && (
                  <div
                    className="profile-image-container"
                    style={{
                      width: '120px',
                      height: '120px',
                      border: '2px solid black',
                      borderRadius: '50%',
                      overflow: 'hidden',
                      boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
                      margin: '0 auto',
                    }}
                  >
                    <img
                      src={profileImage}
                      alt="Profile"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />
                  </div>
                )}
              </Col>
              <Col lg="12" className="text-center">
                <Button
                  style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }}
                  onClick={() => document.getElementById('input-profile-image').click()}
                >
                  <FontAwesomeIcon icon={faPencilAlt} /> Upload Image *
                </Button>
                <FormGroup style={{ display: 'none' }}>
                  <Input
                    type="file"
                    id="input-profile-image"
                    accept="image/*"
                    onChange={handleFileUpload}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row form >
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="vendor_name">Enter Vendor Name</label><span style={{ color: 'red' }}>*</span>
                  <Input
                    className="form-control-alternative"
                    id="vendor_name"
                    type="text"
                    name="vendor_name"
                    onChange={handleVendorInputChange} 
                    placeholder='Enter Vendor Name'
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="vendor_address">Enter Address</label><span style={{ color: 'red' }}>*</span>
                  <Input
                    className="form-control-alternative"
                    id="vendor_address"
                    type="text"
                    name="vendor_address"
                    onChange={handleVendorInputChange}
                    required
                    placeholder='Enter Address'
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="vendor_number">Enter Contact Number</label><span style={{ color: 'red' }}>*</span>
                  <Input
                    className="form-control-alternative"
                    id="vendor_number"
                    type="text"
                    name="vendor_number"
                    onChange={handleVendorInputChange}
                    required
                    placeholder='Enter Contact Number'
                    inputMode="numeric"
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      const paste = (e.clipboardData || window.clipboardData).getData('text');
                      if (!/^[0-9]+$/.test(paste)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="vendor_email">Enter Email</label><span style={{ color: 'red' }}>*</span>
                  <Input
                    className="form-control-alternative"
                    id="vendor_email"
                    type="email"
                    name="vendor_email"
                    onChange={handleVendorInputChange}
                    required
                    placeholder='Enter Email'
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col md={6}>
                <label
                  className="form-control-label"
                  htmlFor="vendor_website"
                >
                  Enter Vendor's Website
                </label>
                <Input
                  className="form-control-alternative"
                  id="vendor_website"
                  type="text"
                  name="vendor_website"
                  value={clientData.vendor_website}
                  onChange={handleVendorInputChange}
                  placeholder="Enter Vendor's Website"
                />
                <h5
                  style={{
                    color: "red",
                    fontWeight: "bold",
                    marginTop: "10px",
                    textAlign: "start",
                  }}
                >
                  It's Optional
                </h5>
              </Col>
            </Row>
            {formError && (
              <div style={{ color: 'red', fontWeight: 'bold', marginBottom: '10px', textAlign: 'center' }}>{formError}</div>
            )}
            <Button type="submit" style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }}>Submit</Button>
          </Form>
        </ModalBody>
      </Modal>
 
      {renderViewMoreModal()} 

      {showSuccessAlert && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
          justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
            maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
          }}>
            <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
            <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{successMessage}</p>
            <Button
              style={{
                backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                padding: '10px 25px', borderRadius: '25px'
              }}
              onClick={() => {
                setShowSuccessAlert(false);
                window.location.reload();
              }}
            >OK</Button>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      <Modal
        isOpen={!!deleteConfirmationEmployeeId}
        toggle={() => toggleDeleteConfirmationModal(deleteConfirmationEmployeeId)}
      >
        <ModalHeader toggle={() => toggleDeleteConfirmationModal(deleteConfirmationEmployeeId)}>
          Confirm Delete
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete this vendor?
          <div className="mt-3 text-right">
            <Button
              color="danger"
              onClick={() => handleDeleteConfirmation(true, deleteConfirmationEmployeeId)}
            >
              Yes, delete
            </Button>{' '}
            <Button
              color="secondary"
              onClick={() => handleDeleteConfirmation(false, deleteConfirmationEmployeeId)}
            >
              No
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default VendorList;